var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0l-.001 2h6L11 0h2l-.001 2H16v13H0V2h2.999L3 0h2zm9 6H2v7h12V6z",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNSI+CiAgPHBhdGggZD0iTTUgMGwtLjAwMSAyaDZMMTEgMGgybC0uMDAxIDJIMTZ2MTNIMFYyaDIuOTk5TDMgMGgyem05IDZIMnY3aDEyVjZ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgDateSort as ReactComponent };